import { combineReducers } from 'redux'

import company from './company/reducer'

export default combineReducers({
  company,
})